import clsx from 'clsx';
import MobiworkxIcon from 'components/assets/mobiworkx-icon.svg';
import Mobiworkxlogo from 'components/assets/MobiworkxLogo.svg';
import A from 'components/atoms/A/A';
import Button from 'components/atoms/Button/Button';
import Txt from 'components/atoms/Txt/Txt';
import LanguagePicker from 'components/molecules/LanguagePicker/LanguagePicker';
import { mobiNavLinks } from 'components/molecules/NavLinks/mobiNavLinks';
import NavLinks from 'components/molecules/NavLinks/NavLinks';
import { DASHBOARD, LOGIN, REGISTRATION } from 'components/pages/pages';
import { useIsLoggedIn } from 'components/templates/AuthenticationProvider/AuthenticationProvider';
import useExternalLink from 'hooks/useExternalLink';
import { useRouter } from 'next/router';
import React from 'react';
import classes from './Header.module.scss';
import UserBalance from './UserBalance';

export interface Props {
  openSidebar?: Function;
  isLandingPage?: boolean;
  withoutSubNav?: boolean;
  brandTakeover?: boolean;
}

const Header: React.FC<Props> = () => {
  const isLoggedIn = useIsLoggedIn();
  const { asPath } = useRouter();

  // The navbar should not be displayed when the user is not logged in.
  const navBar = (
    <>
      <NavLinks navLinkArr={mobiNavLinks} borderPosition="bottom" className={classes.navLinks} />
      <div className={clsx(classes.earnings)}>
        <UserBalance title="Total Earnings" isLink />
      </div>
    </>
  );

  // Mobile view
  // Requires Mobiworkx specific version that appears at the bottom of the page
  const mobileMenu = (
    <div className={classes.dashboardMenu}>
      <div className={classes.earnings}>
        <UserBalance isLink />
      </div>
    </div>
  );

  const loggedOutNavBar = (
    <div className={classes.loggedOutNav}>
      <LanguagePicker className={classes.languagePicker} />
      {asPath.includes('/login') ? (
        <Button component={A} buttonType="primary" href={REGISTRATION.path}>
          <Txt>Sign up</Txt>
        </Button>
      ) : (
        <Button component={A} buttonType="secondary" href={LOGIN.path}>
          <Txt>Sign in</Txt>
        </Button>
      )}
    </div>
  );

  // There should always be a url for 'home', but in case it returns null set to empty string.
  const homePageUrl = useExternalLink('home') || '';
  const logoUrl = (isLoggedIn && DASHBOARD.path) || homePageUrl;
  return (
    <header id="page-header" className={clsx(classes.root, 'hidden-when-embedded')}>
      <div className={clsx(classes.headerContainer, isLoggedIn && classes.isLoggedIn)}>
        <A href={logoUrl}>
          <Mobiworkxlogo id="mobiworkx" className={classes.desktopLogo} width={150} height={50} />
          <MobiworkxIcon className={classes.mobileLogo} width={40} height={26} />
        </A>
        {isLoggedIn ? navBar : null}
        {isLoggedIn ? mobileMenu : loggedOutNavBar}
      </div>
    </header>
  );
};

const MemoizedHeader = React.memo(Header);
export default MemoizedHeader;
